import * as React from "react";
import {Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button} from 'react-bootstrap';
import {EditFeatureGeometry} from "../../../actions/actions";

interface GeometryEditModalProps {
    displayGeometryEditConfirm: boolean;
    setDefaultState: Function;
    editFeatureGeometry: EditFeatureGeometry;
    geometryEditWkt: string;
    editingGeometryFeatureId: string;
    leafletElement: any;
    parent: any;
}

interface GeometryEditModalState {
    reLocalize: boolean;
}

export default class GeometryEditModal extends React.Component<GeometryEditModalProps, GeometryEditModalState> {

    constructor(props: GeometryEditModalProps) {
        super(props);
        this.state = {
          reLocalize: true
        };

    }

    setDefaultState() {
        this.setState({reLocalize: true});
        this.props.setDefaultState(this.props.parent);
    }


    getCheckbox() {
        let change = () => {
            this.setState({reLocalize: !this.state.reLocalize});
        };
        return <span className="re-localize-container">
            <span>Stedfest vegobjekt på nytt </span>
            <input type="checkbox" onChange={change} checked={this.state.reLocalize} />
        </span>;
    }

    render() {
        return <Modal show={this.props.displayGeometryEditConfirm} onHide={()=> this.setDefaultState()}>
            <ModalHeader>
                <ModalTitle>Bekreft redigering av geometri</ModalTitle>
            </ModalHeader>
            <ModalBody>

                <p>Vennligst bekreft at du ønsker å redigere geometrien til vegobjektet. Høydekoordinater blir satt til 0</p>
            </ModalBody>
            <ModalFooter>

                {this.getCheckbox()}
                <Button bsStyle="default" onClick={(e)=> this.setDefaultState()}>Avbryt</Button>
                <Button bsStyle="primary" onClick={(e)=> {
                        this.props.editFeatureGeometry(this.props.editingGeometryFeatureId, this.props.geometryEditWkt, this.state.reLocalize);
                        this.props.leafletElement.off('draw:created');
                        this.setDefaultState();
                    }}>OK</Button>
            </ModalFooter>
        </Modal>;
    }
}

